/*
    Artworks API
 */

// Imports (external)
import { request, gql } from 'graphql-request';
import _ from 'lodash';

// Import Configuration
import config from '../config';

// Import Algolio
import algoliasearch from 'algoliasearch';

// Initialize search index
const client = algoliasearch(config.search.account.applicationId, config.search.account.apiKey);
const index = client.initIndex(config.search.index.artworks.id);

// Orders
const Artworks = {
  // Find artworks (with query)
  find: function(params, callback) {
    // Execute query
    index.search('', {
      filters: `artwork.artist_id:${params.artistId}`,
      page: params.index,
      hitsPerPage: params.take,
      facets: ['enrichments.labels.description']
    }).then(({ hits, facets }) => {
      console.log("Search: ", hits, facets);

      // Extract artworks from records
      const artworks = _.map(hits, 'artwork');
      console.log(" -> ", artworks);

      // Return data
      callback(artworks, facets);
    }).catch((error) => {
      console.error(error);

      // Return empty array
      callback([], []);
    });
  },

  // Search artworks (with query)
  search: function(params, callback) {
    console.log(params);

    // Execute query
    index.search(params.query, {
      filters: `artwork.artist_id:${params.artistId}`,
      page: params.index,
      hitsPerPage: params.take
    }).then(({ hits }) => {
      console.log("Search: ", hits);

      // Extract artworks from records
      const artworks = _.map(hits, 'artwork');
      console.log(" -> ", artworks);

      // Return data
      callback(artworks);
    }).catch((error) => {
      console.error(error);

      // Return empty array
      callback([]);
    });
  }
}

// Export module
export default Artworks;
